<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M1,5 L10,0 L10,10 Z"
    fill="var(--info-background-color)"
  />
  <path
    d="M8,1  L2,4 C0,5 0,5 2,6 L8,9"
    stroke="var(--info-border-color)"
    stroke-width="var(--info-border-width)"
  />
</svg>
